/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { NotificationPolicyConfigEmail } from '../models/NotificationPolicyConfigEmail';
import { NotificationPolicyConfigSlack } from '../models/NotificationPolicyConfigSlack';
import { NotificationPolicyConfigSns } from '../models/NotificationPolicyConfigSns';
import { NotificationPolicyConfigSplunk } from '../models/NotificationPolicyConfigSplunk';
import { NotificationPolicyConfigWebhook } from '../models/NotificationPolicyConfigWebhook';

export class NotificationPolicyConfig {
  'slack'?: NotificationPolicyConfigSlack;
  'email'?: NotificationPolicyConfigEmail;
  'sns'?: NotificationPolicyConfigSns;
  'splunk'?: NotificationPolicyConfigSplunk;
  'webhook'?: NotificationPolicyConfigWebhook;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "slack",
      "baseName": "slack",
      "type": "NotificationPolicyConfigSlack",
      "format": ""
    },
    {
      "name": "email",
      "baseName": "email",
      "type": "NotificationPolicyConfigEmail",
      "format": ""
    },
    {
      "name": "sns",
      "baseName": "sns",
      "type": "NotificationPolicyConfigSns",
      "format": ""
    },
    {
      "name": "splunk",
      "baseName": "splunk",
      "type": "NotificationPolicyConfigSplunk",
      "format": ""
    },
    {
      "name": "webhook",
      "baseName": "webhook",
      "type": "NotificationPolicyConfigWebhook",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return NotificationPolicyConfig.attributeTypeMap;
  }

  public constructor() {
  }
}

